import React from 'react';
import {render} from 'react-dom';
import {createStore, applyMiddleware, compose} from 'redux';
import {routerMiddleware} from 'connected-react-router';
import {createBrowserHistory} from 'history';
import thunk from 'redux-thunk';
import Cookies from 'universal-cookie';
import rootReducer from './reducers';
import Root from './containers/root';
import {checkToken} from './actions/login';
import i18n from './locale/i18n';
import './css/bootstrap.css';
import './css/app.css';
import './css/style.css';
import './css/custom-fonts.css';

const CHUNK_RELOAD_GUARD = 'replayer_chunk_reload_once';

const shouldRecoverFromChunkError = event => {
  if (!event) return false;
  const message = String((event.message || '')).toLowerCase();
  const filename = String((event.filename || '')).toLowerCase();
  const targetSrc = String((((event.target || {}).src) || '')).toLowerCase();
  const text = `${message} ${filename} ${targetSrc}`;
  return text.includes('chunk') || text.includes('loading css chunk') || text.includes('unexpected token \'<\'');
};

window.addEventListener('error', event => {
  if (!shouldRecoverFromChunkError(event)) return;
  if (sessionStorage.getItem(CHUNK_RELOAD_GUARD) === '1') return;
  sessionStorage.setItem(CHUNK_RELOAD_GUARD, '1');
  window.location.reload(true);
}, true);

export const history = createBrowserHistory();

const store = createStore(
  rootReducer(history),
  compose(
    applyMiddleware(
      routerMiddleware(history),
      thunk
    )/*,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()*/
  )
);

const cookies = new Cookies();
const auth = cookies.get('replayerAuth');
const replayerLang = cookies.get('replayerLang');

if (replayerLang) {
  i18n.changeLanguage(replayerLang);
}

const renderApp = () => {
  render(<Root store={store} history={history}/>, document.getElementById('root'));
};

const bootstrap = async () => {
  if (auth) {
    const pathname = (window.location.pathname || '').toLowerCase();
    const publicAnalysisRoute = pathname.startsWith('/analysis/');
    const publicClubRoute = pathname.startsWith('/club/') || pathname.startsWith('/p/');
    const noRedirect = pathname !== '/' && pathname !== '/login';
    try {
      await store.dispatch(checkToken(auth, noRedirect, publicAnalysisRoute || publicClubRoute));
    } catch (error) {
      // Protected routes will redirect to login after rendering if session recovery fails.
    }
  }
  renderApp();
};

bootstrap();
